import { reactive } from "vue";

/**
 * 下载/在线使用免创值资格（义乌教师）
 * 由后端接口 aitool/download/free 决定，前端仅用于展示，最终以服务端为准。
 */
const state = reactive({
  free: false,
  loaded: false,
});

export function getDownloadFree() {
  return state.free;
}

export function setDownloadFree(v) {
  state.free = !!v;
  state.loaded = true;
}

/** 加载当前用户是否免创值，force=true 时强制刷新（登录后调用） */
export async function loadDownloadFree(axiosInstance, force) {
  if (!axiosInstance) return state.free;
  if (state.loaded && !force) return state.free;
  try {
    const res = await axiosInstance({ url: "aitool/download/free", method: "GET" });
    state.free = !!(res && res.code === 200 && res.data && res.data.free);
  } catch (e) {
    state.free = false;
  }
  state.loaded = true;
  return state.free;
}

/** 某个工具对当前用户是否免创值（义乌教师 或 自己的作品） */
export function isToolFree(tool, myUid) {
  if (state.free) return true;
  // 自己的作品始终免费
  return !!(tool && myUid && tool.uid === myUid);
}
